/* eslint-disable react/prop-types */
/* eslint-disable no-console */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-underscore-dangle */
/* eslint-disable object-curly-newline */
/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import {
  Grid, Typography, Card, Button, CircularProgress,
} from '@material-ui/core';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import { useTranslation } from 'react-i18next';
import placementTestServices from '../../../redux/services/placementTestServices';
import { numGradeToEUgradeEW } from '../../../helpers/utils';
import placementTestActions from '../../../redux/actions/placementTestActions';
import config from '../../../config';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    // height: '60vh',
    marginTop: theme.spacing(1),
    position: 'relative',
  },
  mainTitle: {
    marginTop: '1em',
    textAlign: 'center',
  },
  loadingText: {
    marginTop: '1em',
    textAlign: 'center',
    marginBottom: '30px',
  },
  resultCard: {
    textAlign: 'center',
    margin: '1em',
    padding: '2em 0',
    minHeight: '10em',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  gradeTitle: {
    margin: '0 1em',
  },
  grade: {
    color: theme.palette.primary.main,
  },
  button: {
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginBottom: '30px',
  },
  image: {
    width: '35%',
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
}));

const GradeCard = ({ score }) => {
  const classes = useStyles();

  return (
    <Grid item md={3}>
      <Card className={classes.resultCard}>
        {/* <Typography variant="h6" className={classes.gradeTitle}>{title}</Typography> */}
        <Typography variant="h4" className={classes.grade}>{numGradeToEUgradeEW(score)}</Typography>
      </Card>
    </Grid>
  );
};

GradeCard.propTypes = {
  // title: PropTypes.string.isRequired,
  score: PropTypes.number.isRequired,
};

const TestFinished = ({ answers, clearTest, user }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const [scores, setScores] = useState(null);
  const [language, setLanguage] = useState(null);

  const languages = [
    'FR',
    'IT',
    'DE',
    'LU',
    'GB',
  ];

  const [testSend, setTestSend] = useState(false);
  const [reload, setReload] = useState(false);

  useEffect(() => {
    if (!testSend && answers && answers.length > 0) {
      setTestSend(true);
      placementTestServices.getTest(user._id)
        .then(
          (res) => {
            if (res) {
              setScores(res.scores);
              if (res.code?.language) {
                setLanguage(res.code?.language.initial);
              }
              setTestSend(true);
            }
          },
          (error) => {
            console.error(error);
            setTestSend(false);
          },
        );
    }
  }, [reload]);

  setInterval(() => setReload(!reload), 8000);
  const history = useHistory();

  const studentToGroup = () => {
    clearTest();
    history.push('/home');
  };

  return scores ? (
    <Grid container direction="row" className={classes.root} justifyContent="center">
      <Grid item md={12}>
        <Typography className={classes.mainTitle} variant="h5">
          {t('placementTest.results.title', 'Vos résultats:')}
        </Typography>
        <Grid item md={12}>
          <img
            className={classes.image}
            alt={t('placementTest.results.illustrationAlt', 'Illustration test de positionnement')}
            src={`${config.OBJECT_URL}/thumbnail/end-test.svg`}
          />
        </Grid>
      </Grid>

      {(language === null || (language !== null && !languages.includes(language)))
      && <GradeCard title={t('placementTest.results.cards.knowledge', 'Connaissances')} score={scores.scoreKN} />}

      {(language === null || (language !== null && !languages.includes(language)))
      && <GradeCard title={t('placementTest.results.cards.reading', 'Compréhension écrite')} score={scores.scoreRC} />}

      {(language === null || (language !== null && !languages.includes(language)))
      && <GradeCard title={t('placementTest.results.cards.listening', 'Compréhension orale')} score={scores.scoreOC} />}

      <GradeCard score={scores.total} />

      <Grid item md={12}>
        <Button
          className={classes.button}
          color="primary"
          variant="contained"
          onClick={() => studentToGroup()}
        >
          {t('placementTest.results.cta', 'Accéder à la plateforme')}
        </Button>
      </Grid>
    </Grid>
  ) : (
    <Grid container direction="column" className={classes.root} justifyContent="center" alignItems="center">
      <Typography className={classes.loadingText} variant="h5">
        {t('common.loading', 'Chargement en cours')}
      </Typography>
      <CircularProgress />
    </Grid>
  );
};

TestFinished.propTypes = {
  answers: PropTypes.array.isRequired,
  clearTest: PropTypes.func.isRequired,
};

const actionCreators = {
  clearTest: placementTestActions.clearTestOtherLanguage,
};

function mapState(state) {
  const { user } = state.user;
  // const { semester, company, _id } = user;
  return {
    user,
  };
}
export default connect(mapState, actionCreators)(TestFinished);
